export default __webpack_public_path__ + "static/media/hover5.e531484a.png";